export default __webpack_public_path__ + "static/media/Google-gray.b763e805.png";